import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * 預設策略只在 routeConfig 不同時重建元件，導致「同一路由、不同路徑參數」
 * （例如從 places/PLACE_A 切到 places/PLACE_B）會重用元件而不重新載入，
 * 使用者必須手動重新整理才會看到新場域內容。
 *
 * 此策略在路由設定相同、但路徑參數不同時強制重建元件，
 * 讓側欄常用連結／場域間切換可以即時跳轉。
 * 僅查詢字串（query params）變動時仍維持重用，不影響 imaginus 對話等情境。
 */
export class ParamAwareRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    if (future.routeConfig !== curr.routeConfig) {
      return false;
    }
    return this.sameParams(future.params, curr.params);
  }

  private sameParams(a: Record<string, any>, b: Record<string, any>): boolean {
    const aKeys = Object.keys(a || {});
    const bKeys = Object.keys(b || {});
    if (aKeys.length !== bKeys.length) {
      return false;
    }
    return aKeys.every((key) => a[key] === b[key]);
  }
}
